<template>
  <container>
    <race-header title="New Race">
    </race-header>
    <custom-form :handle-submit="handleSubmit" style="marginBottom: 40px">
      <text-field v-model="race.name" label="Name" name="name" v-validate="'required'" maxlength="5"  data-vv-value-path="input" data-vv-name="name" error-message="Fill in the name" :has-error=" errors.has('name')" :required="true"></text-field>
   <div class="form__group">
          <label for="description">Description <span class="required">*</span></label>
         <textarea v-validate data-vv-rules="required" :class="{'form-control': true, 'is-danger': errors.has('description') }" name="description" rows ="6" v-model="race.description" id="txtArea" onkeypress="onDescriptionChange" required></textarea>
          <span v-show="errors.has('description')" class="help is-danger">Fill in the description</span>
        </div>

      <date-time-field v-model="race.date" :label="`Date - ${getTimezone()}`" name="date" v-validate="'required'" data-vv-value-path="startDate.time" data-vv-name="date" error-message="Fill in the date" :has-error=" errors.has('date')" :required="true"></date-time-field>

      <div class="form__group" style="display: inline-flex">
          <input type="checkbox" v-model="isRepeatShift" id="repeatShift" name="repeatShift"  @change="onChecked()">
          <label class="repeatShiftLabel" for="repeat-shift">Repeat Shift</label>
           <div style="display: inline-flex;"  v-bind:class="{'hide' : !isRepeatShift}" >
            <span class="repeatEvery">Repeat Every : </span>
            <div>
            <select class="repeatDays" v-model="race.interval" name="repeatDays"
              v-validate="isRepeatShift?'required':''"  :required="isRepeatShift"  >
                    <option value="EVERY_WEEK">Every Week</option>
                    <option value="EVERY_2_WEEKS">Every 2 Weeks</option>
                    <option value="EVERY_MONTH">Every Month</option>
            </select>
            <span v-show="errors.has('repeatDays')" class="help is-danger">Fill in the Repeat Days</span>
            </div>
            <span class="ending">Ending : </span>
              <date-time-field class="endingDate" v-model="race.end_interval" :isRepeatField="true"
              name="endDate" v-validate="isRepeatShift?'required':''" data-vv-value-path="startDate.time"
              data-vv-name="endDate" error-message="Fill in the End date"
              :has-error="errors.has('endDate')" :data-vv-rules="isRepeatShift?'required':''" :required="isRepeatShift">
             </date-time-field>
          </div>
      </div>



      <div class="form__group">
          <label for="duration">Duration(in minutes):</label>
          <input v-validate data-vv-rules="required" :class="{'form-control': true,  'is-danger': errors.has('duration') }" type="number" step="1"  min="1"  :max="max_duration"  name="duration" v-model="race.duration" required>
          <span v-show="errors.has('duration')" class="help is-danger">Fill in the duration</span>
        </div>

 <div class="form__group">
    <div style="display: inline-flex;" >
       <div style="margin-right: 100px;">
          <label for="type">First Type:</label>

          <select v-model="race.type" label="First Type" name="type" style="height: 33px;">
            <option value="LIVE"> Live (Medal) </option>
            <option value= "NO_MEDAL"> No Medal </option>
            <option value= "ON_DEMAND_MEDAL"> On demand (Medal)</option>
            <option value= "ON_DEMAND_NO_MEDAL"> On demand (No Medal) </option>
          </select>
        </div>

        <div v-if="race.type == 'ON_DEMAND_MEDAL' || race.type == 'ON_DEMAND_NO_MEDAL'">
           <race-media  v-model="race.audioFileUrl" label="On demand File" name="media"  data-vv-value-path="input" data-vv-name="media" error-message="Fill in the audio" :has-error=" errors.has('media')" :required="false"></race-media>
        </div>

    </div>

  </div>



      <div class="form__group">
        <label for="type">Second Type:</label>
          <select v-model="race.secondType" label=" Second Type" name="secondType" >
            <option v-for="type in raceTypes" v-bind:value="type.name">{{type.englishText}}</option>
          </select>
      </div>

      <div class="form__group">
        <label for="type">Third Type:</label>
          <select v-model="race.thirdType" label="Third Type" name="thirdType" >
                  <option value=''> NONE </option>
                  <option value='NO_MEDAL'> NO MEDAL </option>
                  <option value="PromoL"> L </option>
                  <option value="PromoI"> I </option>
                  <option value="PromoV"> V </option>
                  <option value="PromoE"> E </option>
                  <option value="LIVE_60MIN"> 60MIN_MEDAL </option>
                  <option value="PromoU"> U </option>
                  <option value="PromoR"> R </option>
                  <option value="MEDAL_20K"> 20Km Medal </option>
          </select>
      </div>


      <div class="form__group">
        <label for="type">Channel:</label>
          <select v-model="race.mobileChannelToPlay" label="Channel" name="channel" style="width: 9%;" >
                  <option :value= channels.audioChannelA > A </option>
                  <option :value= channels.audioChannelB> B </option>
                  <option :value= channels.audioChannelC> C </option>
                  <option :value= channels.audioChannelD> D </option>
          </select>
      </div>
       <div class="form__group">
        <label for="type"> Language:</label>
          <select v-model="race.language" label="Language" name="language" >
            <option v-for="locale in locales" v-bind:value="locale.id">{{locale.name}}</option>
          </select>
      </div>

      <div class="form__group">
          <label for="type">RSVP Limit:</label>
          <input v-validate data-vv-rules="required" :class="{'form-control': true,  'is-danger': errors.has('rsvp_limit') }" type="number" step="1"  min="1"  :max="max_rsvp_limit"  name="rsvp_limit" v-model="race.rsvp_limit" required>
          <span v-show="errors.has('rsvp_limit')" class="help is-danger">Fill in the RSVP limit</span>
      </div>

      <div class="form__group" style="display: inline-flex;">
        <div style="width: 34rem;margin-right: 20px;">
          <label for="type">Action URL:</label>
          <text-field v-model="race.endSessionUrl"  name="endSessionUrl"  data-vv-value-path="input" data-vv-name="name" ></text-field>
        </div>
        <div style="width: 35rem">
           <race-photo v-model="race.actionImageUrl" label="Action Image" name="actionImage"  data-vv-value-path="input" data-vv-name="actionImage" error-message="Fill in the photo with size below 200 Kb" :has-error="errors.has('actionImage')" :required="false"></race-photo>
        </div>
      </div>



      <div class="form__group race-tags" >
         <label for="type"> Tags:</label>
          <selectize v-bind:options="tagsOptions" v-model="selectedTags" multiple size="1" :isRunnerTag=false
            data-dropdown-parent="body" data-max-options="100"
            data-value-field= 'id' data-label-field='name' data-search-field= 'name' data-sort-field= 'name'
            style="visibility:hidden">
          </selectize>
      </div>

       <div class="form__group"  style="display: inline-flex">
          <label class="randomClubTag" for="randomClubTag">Random Club Tag : </label>
          <input type="checkbox" v-model="race.randomClubTag" id="randomClubTag" name="randomClubTag" style="transform: scale(1.3);margin:2px 9px">
        </div>


      <div>
        <div v-if="race.imageUrl">
          <p>Current photo race:</p>
          <img :src="race.imageUrl" width="200px">
        </div>
       <upload-photo v-model="race.imageUrl" label="Photo" name="photo" v-validate="'required'" data-vv-value-path="input" data-vv-name="photo" error-message="Fill in the photo with size below 200 Kb" :has-error=" errors.has('photo')" :required="true"></upload-photo>
      </div>

      <div class="form__group">
        <label for="type"> Trainer:</label>
          <select v-model="trainerId" label="Trainer" name="Trainer"  @change="changeTrainer" class="trainer-list">
            <option v-for="(trainer, index) in trainerList" v-bind:value="trainer.id" :key="index">{{trainer.firstName}}</option>
          </select>
      </div>


      <button class="btn btn--primary" id="submit-form">Create Race</button>

      <router-link to="/admin/races" id="Cancel" class="btn btn--primary" >Cancel</router-link>

    </custom-form>
  </container>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  import Container from '@/components/Container'
  import RaceHeader from '@/components/Race/Header'
  import CustomForm from '@/components/Forms/Form'
  import TextField from '@/components/Forms/TextField'
  import IntegerField from '@/components/Forms/IntegerField'
  import DateTimeField from '@/components/Forms/DateTimeField'
  import RacePhoto from '@/components/Forms/RacePhoto'
  import UploadPhoto from '@/components/Forms/UploadPhoto'
  import RaceMedia from '@/components/Forms/RaceMedia'
  import SettingsService from "@/services/settings"
  import TrainerService from '@/services/trainer'
  import Selectize from '@/components/Selectize'
  import TagService from '../../services/tag'
  import RaceService from '../../services/races'
  import { db} from '../../firebase'
  export default {
    name: 'CreateRace',
    data: () => ({
      race: {
        name: '',
        description: '',
        notes: '',
        date: '',
        startDate: '',
        finishDate: '',
        type: 'LIVE',
        secondType:'RUN_OR_WALK',
        thirdType:'', //https://app.asana.com/0/1137425856170315/1200180518958154
        //thirdType:'NO_MEDAL',
        mobileChannelToPlay:'',
        language:'ja',
        imageUrl: '',
        audioFileUrl:'',
        duration: null,
        rsvp_limit:1000,
        randomClubTag:false,
        endSessionUrl: ""
        //end_interval:'',
        //interval:''
      },
      locales: [ {id: 'en', name: 'English'}, {id: 'ja', name: 'Japanese'}],
      types:[],
      channels:{},
      tagsOptions:[],
      selectedTags:[],
      isRepeatShift:false,
      repeatEvery:'',
      endDate:'',
      trainerList:[],
      trainerId:'',
      raceTrainer:'',
      raceTypes:[],
      max_duration: 1440, // 24 hours in minutes
      max_rsvp_limit: 10000 // Maximum RSVP participants
    }),
    computed: {
      ...mapGetters({
        trainer: 'Trainer/trainer'
      })
    },
    methods: {
      handleSubmit() {
        //console.log("this.raceinn---",this.race)

        if(this.race.thirdType == ''){
          this.race.thirdType = null
        }

        var tagList =[]
        this.selectedTags.forEach(tag => {
          tagList.push({'id':parseInt(tag)})
        })
        this.race.tags= tagList

        this.$validator.validateAll()
          .then(success => {
            if (!success) {
              return
            }

            //this.race.trainer = this.trainer
            this.race.trainer = this.raceTrainer // CHANGE THE TRAINER OF SESSION

            this.loadingUpdateButton()

            this.createRace(this.race)
              .then((resp) => {
                console.log("respo---",resp.data)
                // if(resp.data.id){
                //   this.selectedTags.forEach(tag => {
                //      TagService.addRaceTag(resp.data.id,tag).then((response)=>{
                //         console.log("addRaceTag---",tag)
                //     })
                //   })
                // }
                var respData = resp.data
                var that = this
                console.log("resp.data.raceIdsInterval---",respData.raceIdsInterval)
                var RaceId = respData.id
                this.addValueInFirebase(respData,RaceId)
                // db.ref(`/${this.$fbDbEntry}/${respData.id}`).update({
                //   'streamingUrl': respData.mobileChannelToPlay,
                //   'endSessionUrl':respData.endSessionUrl //Add Action url in Firebase
                // }).catch(error => {
                //   console.log("Firebase error--",error)
                // })
                var that = this
                if(respData.raceIdsInterval != undefined){
                  respData.raceIdsInterval.forEach(function (raceId) {
                    console.log("---",raceId)
                    that.addValueInFirebase(respData,raceId)
                    // db.ref(`/${that.$fbDbEntry}/${raceId}`).update({
                    //   'streamingUrl': respData.mobileChannelToPlay,
                    //   'endSessionUrl':respData.endSessionUrl //Add Action url in Firebase for repeating races
                    // }).catch(error => {
                    //   console.log("Firebase error--",error)
                    // })
                  })
                }

                this.$router.push({
                  path: '/admin/races'
                })
                this.error = ''
                this.resetUpdateButton()
              })
              .catch(() => {
                this.error = 'Failed!'
                this.resetUpdateButton()
              })
          })
      },
      addValueInFirebase(respData , raceId){
        db.ref(`/${this.$fbDbEntry}/${raceId}`).update({
          'streamingUrl': respData.mobileChannelToPlay,
          'endSessionUrl':respData.endSessionUrl //Add Action url in Firebase
        }).catch(error => {
          console.log("Firebase error--",error)
        })
      },
      // onChecked(){
      //   console.log("innnnnn",this.isRepeatShift)
      // },
      ...mapActions({
        createRace: 'Race/createOne',
        getRaceTypes:'Race/getTypes'
      }),
      loadingUpdateButton() {
        const btnUpdate = document.querySelector('#submit-form')
        btnUpdate.innerHTML = 'Creating...'
        btnUpdate.setAttribute('disabled', true)
      },
      resetUpdateButton() {
        const btnUpdate = document.querySelector('#submit-form')
        btnUpdate.innerHTML = 'Create Race'
        btnUpdate.removeAttribute('disabled', true)
      },
      getTimezone() {
        return new Date().toString().match(/([A-Z]+[+-][0-9]+.*)/)[1]
      },
      onDescriptionChange() {
          var key = window.event.keyCode
          // If the user has pressed enter
          if (key === 13) {
              document.getElementById("txtArea").value = document.getElementById("txtArea").value + "\n*"
              return false
          }
          else {
              return true
          }
      },
      async getExistingChannels(){
        const channels = await SettingsService.get()
        this.channels = channels.data
        this.race.mobileChannelToPlay = channels.data.audioChannelA
        return channels.data
      },
       getAllTags(){
        //Session Creation : Randomly tag "club".
         var randomNum = Math.round(Math.random())
         var that = this
         TagService.getAllTags().then((response)=>{
           console.log("response----",response)
            this.tagsOptions = response.data
            //Session Creation : Randomly tag "club".
            if(randomNum==1){
              setTimeout(function(){   that.selectedTags = ["35"] }, 100)
            }
         })
      },
      getTrainerList(){
        var that = this
        setTimeout(function(){
          //SET CURRENT LOGIN TRAINER BY DEFAULT
          that.trainerId = that.trainer.id
          that.raceTrainer = that.trainer
        }, 1000)
        //GET TRAINER LIST
        TrainerService.getAll().then(response => {
          if(response.data && response.data != undefined && response.data != ''){
            this.trainerList = response.data
          }
        }).catch(error => {
          console.log("Error get all trainer--->>",error)
        })
      },
      changeTrainer(){
        // CHANGE THE TRAINER OF SESSION
        TrainerService.getTrainer(this.trainerId).then(response => {
         this.raceTrainer = response.data
        }).catch(error => {
          console.log("Error Get trainer by id--->>",error)
        })
      },
      getRaceTypeAvailable(){
        RaceService.getRaceTypeAvailable().then(response => {
          console.log("response>>>",response.data)
            if(response.data && response.data != undefined && response.data != ''){
              let allRaceTypes = response.data
              //Remove these from the second type (https://app.asana.com/0/1137425856170315/1200251895400268)
              let removeItem =["SOLO","PromoL","PromoI","PromoV","PromoE","PromoU","PromoR","NO_MEDAL","LIVE_60MIN","ON_DEMAND_MEDAL","ON_DEMAND_NO_MEDAL","WALK"]
              var removeElements = _.remove(allRaceTypes, obj => removeItem.includes(obj.name))
              // var addElements = allRaceTypes.push({englishText: 'PromoU', name: 'PromoU', japaneseText: 'PromoU'}, {englishText: 'PromoR', name: 'PromoR', japaneseText: 'PromoR'})
              this.raceTypes = allRaceTypes
              // this.raceTypes = allRaceTypes.push( {englishText: 'PromoU', name: 'PromoU', japaneseText: 'PromoU'}, {englishText: 'PromoR', name: 'PromoR', japaneseText: 'PromoR'})
              //this.raceTypes = response.data
            }
          }).catch(error => {
            console.log("Error getting race type--->>",error)
          })
      }
    },
    created(){
      this.getAllTags()
      this.getExistingChannels()
      this.getTrainerList()
      this.getRaceTypeAvailable()
      this.getRaceTypes().then(res =>{
        res.data.unshift('NONE')
        this.types = res.data
      })
    },
    components: {
      Container,
      RaceHeader,
      CustomForm,
      TextField,
      IntegerField,
      DateTimeField,
      RacePhoto,
      UploadPhoto,
      RaceMedia,
      Selectize
    }
  }
</script>

<style>
.race-tags .selectize-control{
  width: 40%;
}
.race-tags .selectize-control.multi .selectize-input>div.active {
   background: #efefef;
    color: #000;
    border: 0 solid transparent;
}
.race-tags .selectize-control.multi .selectize-input>div{
  color: #000;
  margin: 0 10px 3px 0;
}
input#repeatShift {
    transform: scale(1.3);
    margin: 0px 10px 0 0px;
}
label.repeatShiftLabel {
    font-size: 14px;
    width : 160px;
    margin-top: -1px;
    color: #ef256c;
}
span.repeatEvery {
    width: 100px;
    margin-top: -1px;
}
span.ending {
    width: 60px;
    margin-top: -1px;
}
.form__group.endingDate {
    margin-top: -3px;
}
.hide{
  visibility: hidden;
}
select.repeatDays {
    margin: -3px 70px 0px 0px;
    height: 20px;
}
</style>







// WEBPACK FOOTER //
// Create.vue?234241b4